// Bottom tabs mobile (rfc-006 §4.1) — maks 4 tab langsung + "Lainnya"
// (sheet penuh) bila item terlihat > 5. Difilter permission via lib/nav.

import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { MoreHorizontal } from "lucide-react";
import { Sheet, SheetBody, SheetContent, SheetHeader, SheetTitle } from "@ds/ui";
import { cn } from "@ds/lib/utils";
import { useAuth } from "../../lib/auth";
import { splitBottomTabs } from "../../lib/nav";

const tabClass = (active: boolean) =>
  cn(
    "flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[0.7rem] font-medium",
    active ? "text-primary" : "text-muted",
  );

export function BottomTabs() {
  const { can } = useAuth();
  const { tabs, more } = splitBottomTabs(can);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const moreActive = more.some((item) => location.pathname.startsWith(item.path));

  return (
    <>
      <nav
        className="z-sticky fixed inset-x-0 bottom-0 flex border-t border-border bg-surface lg:hidden"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        {tabs.map((item) => (
          <NavLink key={item.key} to={item.path} className={({ isActive }) => tabClass(isActive)}>
            <item.icon className="size-5" aria-hidden />
            {item.label}
          </NavLink>
        ))}
        {more.length > 0 && (
          <button type="button" className={tabClass(moreActive)} onClick={() => setOpen(true)}>
            <MoreHorizontal className="size-5" aria-hidden />
            Lainnya
          </button>
        )}
      </nav>

      {more.length > 0 && (
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetContent side="bottom">
            <SheetHeader>
              <SheetTitle>Lainnya</SheetTitle>
            </SheetHeader>
            <SheetBody>
              <div className="grid grid-cols-3 gap-3">
                {more.map((item) => (
                  <NavLink
                    key={item.key}
                    to={item.path}
                    onClick={() => setOpen(false)}
                    className="flex flex-col items-center gap-1.5 rounded-lg border border-border p-4 text-center text-sm font-medium hover:bg-faint"
                  >
                    <item.icon className="size-6" aria-hidden />
                    {item.label}
                  </NavLink>
                ))}
              </div>
            </SheetBody>
          </SheetContent>
        </Sheet>
      )}
    </>
  );
}
